import { render, staticRenderFns } from "./Loanables.vue?vue&type=template&id=97179f46&"
import script from "./Loanables.vue?vue&type=script&lang=js&"
export * from "./Loanables.vue?vue&type=script&lang=js&"
import style0 from "./Loanables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports